import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import NoDataPlaceHolder from "components/common/NoDataPlaceHolder";
import { useBusinessContext } from "BusinessApp";

function MoneyLine({ color, text, money, last }) {
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{money || 0}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartCustomers({ dataHeader, loading, firstGraph, emptyData }) {
  const { t } = useTranslation();
  const { currencyFormat } = useBusinessContext();

  return (
    <s.Container ref={firstGraph}>
      <s.Title>{t("containers.ReportsCustomers.customerTypes")}</s.Title>

      {loading ? (
        <Loading height="340px" size="middle" />
      ) : emptyData ? (
        <NoDataPlaceHolder height="340px" />
      ) : (
        <>
          <div style={{ width: "140px", margin: "0 auto 40px " }}>
            <PieChartCustom
              data={[
                {
                  name: t("containers.ReportsCustomers.business"),
                  value: parseFloat(dataHeader.customerSalesBusiness).toFixed(
                    2
                  ),
                  color: Colors.text_on_primary,
                  background: Colors.primary_web,
                },
                {
                  name: t("containers.ReportsCustomers.customer"),
                  value: parseFloat(dataHeader.customerSalesPerson).toFixed(2),
                  color: `${Colors.primary_web}100`,
                  background: `${Colors.primary_web_color1}90`,
                },
                {
                  name: t("containers.ReportsCustomers.NoDefined"),
                  value: parseFloat(dataHeader.notCustomerSales).toFixed(2),
                  color: `${Colors.primary_web}90`,
                  background: `${Colors.primary_web_color1}40`,
                },
              ]}
            />
          </div>

          <MoneyLine
            color={Colors.primary_web}
            text={t("containers.ReportsCustomers.business")}
            money={currencyFormat(dataHeader.customerSalesBusiness)}
          />
          <MoneyLine
            color={`${Colors.primary_web_color1}90`}
            text={t("containers.ReportsCustomers.customer")}
            money={currencyFormat(dataHeader.customerSalesPerson)}
          />
          <MoneyLine
            color={`${Colors.primary_web_color1}40`}
            text={t("containers.ReportsCustomers.NoDefined")}
            money={currencyFormat(dataHeader.notCustomerSales)}
          />
        </>
      )}
    </s.Container>
  );
}

export default PieChartCustomers;
